// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35E9P","title":"styles_title__3vLEc"};